import './assets/common.less';
import './assets/detail.less';             


// WEBPACK FOOTER //
// ./src/detail.js